export default __webpack_public_path__ + "static/media/loading.3f2ea3ba.mp4";